import { PageVisitTracker } from "@/analytics/PageVisitTracker";
import { setBrandColors } from "@/hooks/useBrandColors";
import React, { useLayoutEffect } from "react";
import Footer from "../Navigation/Footer";
import Navbar from "../Navigation/Navbar";

interface Proptypes {
  children: React.ReactNode;
}
// background: linear-gradient(rgb(238, 252, 252) 0%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgb(238, 252, 252) 0%, rgb(255, 255, 255) 100%);

const PublicLayout = ({ children }: Proptypes) => {
  useLayoutEffect(() => {
    if (window.partner) {
      const partner = window.partner;
      document.title = partner.title + " Employee Portal";
      setBrandColors({ brandColor: partner.colors.primary });
      const favicon = document.querySelector(
        'link[rel="icon"]',
      ) as HTMLLinkElement;

      if (favicon && partner.favicon) {
        favicon.href = partner.favicon;
      }
    }
  }, []);

  return (
    <div className="h-screen flex flex-col max-h-screen">
      <Navbar />
      <PageVisitTracker />
      <main
        style={{
          background: `linear-gradient(180deg, var(--sootchy-bg-75) 0%, #FFF 100%), linear-gradient(90deg, var(--sootchy-bg-75) 0%, #FFF 100%)`,
        }}
        className="flex-grow h-[calc(100vh-var(--navigation-height)-var(--footer-height))]] flex flex-col"
      >
        <div className="w-full h-full">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
